import { authenticationService } from '@core/services/authentication/AuthenticationService';
import { wafService } from '@core/services/waf/WafService';
import { loadIovation } from '@modules/iovation';
import { RouteName } from '@src/app/router/constants/RouteName';
import { currentSite } from '@src/app/utils/domainHelpers';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import {
    reformatDate,
    DateFormat,
} from '@superbet-group/web.lib.utilities';
import { AccountInitArgs } from 'account/initializeFederation';
import {
    getRegistrationType,
    setRegistrationType,
} from './modules/registration/registrationType';
import { useRegisterLogic } from './modules/registration/useRegisterLogic';
import { useCountriesList } from './utils/useCountriesList';
import { useHeaderBackbuttonOverride } from '@src/app/mobile/navbar/composables/useHeaderBackbuttonOverride';
import { getDarklyExpId } from '@src/app/shared/featureFlags/isAlternativeRegistrationEnabled';
import { getIsMojeIdEnabled } from './modules/dynamicForm/utils';
import nationalities from '@accountCountries/registration/nationalities';
import { isoCode2ToIsoCode } from '@sportOfferFederation/flags/flagsDefinitions';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { antiFraudService } from '@core/services/antiFraud/AntiFraudService';
import { getConfig } from '@superbet-group/web.lib.config';
import { useRegistrationInterceptor } from './modules/registration/useRegistrationInterceptor';

/**
 * Temporary compatibility layer until proper extraction and separation is done
 */
export function getTemporaryMappings(): Pick<AccountInitArgs, 'services' | 'utils' | 'routeNames' | 'modalCodes'> {
    return {
        services: {
            getIdentityProviderUrl: authenticationService.getIdentityProviderUrl.bind(authenticationService),
            isRegisterFieldValid: authenticationService.isRegisterFieldValid.bind(authenticationService),
            validateRegistrationData: authenticationService.validateRegistrationData.bind(authenticationService),
            wafServiceInstance: wafService,
            useRegisterLogic,
            useRegistrationInterceptor,
            getKYCMojeIdResponse: authenticationService.getKYCMojeIdResponse.bind(authenticationService),
        },
        utils: {
            // avoid lib update clashes until dep is removed from fed
            normalizeDateOfBirth: (value: string) => reformatDate(value, DateFormat.Slashddmmyyyy, DateFormat.Slashddmmyyyy),
            croatianToStandardDateFormat: (value: string) => reformatDate(value, DateFormat.Slashddmmyyyy, DateFormat.Dashyyyymmdd),
            loadIovation,
            setRegistrationType,
            getFlagByIsoCode: (code: string) => isoCode2ToIsoCode[code],
            useCountriesList,
            useHeaderBackbuttonOverride,
            getDarklyExpId,
            getIsMojeIdEnabled,
            getRegistrationType,
            initializeAntiFraud: () => {
                if (shellLocalConfig.seonConfig.register.isServiceEnabled) {
                    antiFraudService.initialize(getConfig().antiFraud);
                }
            },
            currentSite,
            nationalities,
        },
        routeNames: getMappedRoutesUnion(),
        modalCodes: getMappedModalCodes(),
    };
}

function getMappedRoutesUnion() {
    // Avoid breaking fed by route name changes during extraction
    const specificMapping = {
        ContinueRegistrationMappedName: RouteName.Account.ContinueRegistration,
        DepositMappedName: RouteName.Account.Deposit,
        RegisterMappedName: RouteName.Account.Register,
        SportsCategory: RouteName.Sport.Category,
    };

    return {
        ...specificMapping,
        ...RouteName,
    };
}

function getMappedModalCodes() {
    // Avoid breaking fed by modal code changes during extraction
    const specificMapping = {
        LoginModalCode: modalCodes.login,
        exitRegister: modalCodes.exitRegister,
    };

    return {
        ...specificMapping,
        ...modalCodes,
    };
}
